/*!
 * jwk/constants.js - Constants for JWKs
 *
 * Copyright (c) 2015 Cisco Systems, Inc. See LICENSE file.
 */
"use strict";

module.exports = {
  MODE_SIGN: "sign",
  MODE_VERIFY: "verify",
  MODE_ENCRYPT: "encrypt",
  MODE_DECRYPT: "decrypt",
  MODE_WRAP: "wrap",
  MODE_UNWRAP: "unwrap"
};
